import './styles/component.reviews-card.scss';
import { isNullOrUndef } from '../js/helpers/isNullOrUndef';
class ReviewCardComponent extends HTMLElement {
    opened = false;
    text;
    constructor() {
        super();
        this.addEventListener('click', () => {
            if (isNullOrUndef(this.text))
                return;
            if (this.opened) {
                this.dataset.stateOpened = '0';
                this.dataset.stateScrollable = '0';
                this.text.scrollTop = 0;
                this.opened = false;
            }
            else {
                this.dataset.stateOpened = '1';
                if (this.text.scrollHeight > this.text.clientHeight) {
                    this.dataset.stateScrollable = '1';
                }
                this.opened = true;
            }
        });
    }
    connectedCallback() {
        this.text = this.querySelector('[data-review-text]');
    }
}
customElements.define('review-card-component', ReviewCardComponent);
